import { FC } from 'react'

import { AttributeSection } from '@syconium/little-miss-figgy'

import { EmbroiderySectionTitle } from '../../../../../../../components/embroidery/EmbroiderySectionTitle/index'
import { EmbroiderySectionWrapper } from '../../../../../../../components/embroidery/EmbroiderySectionWrapper/index'
import { B2bLogoSneakPeek } from '../../../../../../../components/embroidery/EmbroiderySneakPeek/B2bLogoSneakPeek'
import {
  EditButton,
  EmbroideryLabel,
} from '../../../../../../../components/embroidery/EmbroiderySummary/styles'
import {
  useEmbroidery,
  useEmbroideryDialog,
} from '../../../../../../../containers/EmbroideryContainer/EmbroideryProvider'
import { hashPrefixed } from '../../../../../../../lib/utils/color'
import { useTranslation } from '../../../../../../_providers/TranslationProvider.client'

export const B2BLogoEmbroiderySection: FC = () => {
  const {
    productColorHex,
    embroiderySelections,
    requiredEmbroideryTypes,
    disabledFormFields,
    isTeamStoreEmbroidery,
  } = useEmbroidery()
  const { open: openEmbroideryModal } = useEmbroideryDialog()
  const isRequired = requiredEmbroideryTypes.includes('LOGO')
  // Only team stores can customize placement; portals have a fully pre-configured logo.
  // Within team stores, hide Customize when the org has locked placement via a defaultPlacement.
  const isPlacementLocked = disabledFormFields?.LOGO_B2B?.includes('logoPlacement') ?? false
  const showCustomize = isTeamStoreEmbroidery && !isPlacementLocked
  const logoSneakPeekBackgroundColor = hashPrefixed(productColorHex)

  const {
    embroidery: { logoTitle, customize },
  } = useTranslation()

  const title = (
    <EmbroideryLabel>
      <EmbroiderySectionTitle isRequired={isRequired}>{logoTitle}</EmbroiderySectionTitle>
      {showCustomize && (
        <EditButton type='button' onClick={openEmbroideryModal}>
          {customize}
        </EditButton>
      )}
    </EmbroideryLabel>
  )

  return (
    <EmbroiderySectionWrapper data-testid='b2b-logo-embroidery-section'>
      <AttributeSection title={title}>
        <B2bLogoSneakPeek
          backgroundColor={logoSneakPeekBackgroundColor}
          imgSrc={embroiderySelections.LOGO_B2B?.logoImageSource}
          logoName={embroiderySelections.LOGO_B2B?.logoName}
          logoPlacement={embroiderySelections.LOGO_B2B?.logoPlacement}
        />
      </AttributeSection>
    </EmbroiderySectionWrapper>
  )
}
